import store from '@/store';
import { Dialog } from 'vant';
import wechat from '@/libs/wechat';
import api from '@/api';
import storage from '@/libs/storage';
import { Base64 } from 'js-base64';
import { typeOf } from 'plupload';
import CryptoJS from 'crypto-js';

export default {
  install(Vue) {
    Vue.prototype.cf = this;
    this.$storage = Vue.prototype.$storage;
  },
  formatTime(date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return [year, month, day].map(formatNumber).join('-');
  },
  AesDecrypt(word) {
    if(word.length != 24) {
      return word;
    }
    const key = CryptoJS.enc.Latin1.parse("0102030405060708"); //十六位十六进制数作为秘钥
    const iv = CryptoJS.enc.Latin1.parse('0102030405060708');
    const decoded = CryptoJS.AES.decrypt(word, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      adding: CryptoJS.pad.ZeroPadding
     }).toString(CryptoJS.enc.Utf8)
     return decoded;
  },
  wxShareConf() {
    if (wechat.bridge.isWeChatMiniProgram) {
      var domain = window.location.host;
      var title = '线上运动会'
      if (domain.indexOf('bk.h5.movecloud.cn') === -1) title = '　'
      var shareConf = {
        title: title,
        path:
          '/pages/webview/index?src=' + encodeURIComponent(window.location.href),
      }
      wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) });
    } else if (this.isWeChat()) {
      let link = `${window.location.protocol}//${window.location.host}${window.entryUrl}`
      storage.get("t").then((res) => {
        if (!!res) {
          res = res.replace(/^\s+|\s+$/gm, '');
          if (link.indexOf("?") === -1) {
            link = link + "?t=" + res
          } else {
            link = link + "&t=" + res
          }
        }
        storage.get('shareInfo').then((res) => {
          if (!!res) {
            return wechat.updateShareData(Object.assign(res, {
              link
            }))
          } else {
            return wechat.updateShareData({
              title,
              link
            })
          }
        })
      })
    }
  },
  isJSON(str) {
    if (typeof str === 'string') {
      try {
        if (str.indexOf('{') > -1) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    } else if (typeof str === 'object') {
      return true;
    }
    return false;
  },
  isEmpty(val) {
    // null or undefined
    if (val == null) return true;

    if (typeof val === 'boolean') return false;

    if (typeof val === 'number') return !val;

    if (val instanceof Error) return val.message === '';

    switch (Object.prototype.toString.call(val)) {
      // String or Array
      case '[object String]':
      case '[object Array]':
        return !val.length;

      // Map or Set or File
      case '[object File]':
      case '[object Map]':
      case '[object Set]': {
        return !val.size;
      }
      // Plain Object
      case '[object Object]': {
        return !Object.keys(val).length;
      }
    }

    return false;
  },
  setLastRouter(to) {
    let { name, query, params } = to;
    let lastrouter = { name, query, params };
    this.$storage.set('lastroute', lastrouter);
  },
  async getLastRouter() {
    return this.$storage.get('lastroute').then((res) => {
      let lastroute = res;
      if (!res) {
        lastroute = { name: 'index' };
      }
      return lastroute;
    });
  },
  isWeChat() {
    return /micromessenger/i.test(window.navigator.userAgent);
  },
  async getToken() {
    return await storage.get("userInfo").then(res=>{
      if(res && res.access_token) return res.access_token
    })

    // if(userinfo && userinfo.access_token) return userinfo.access_token
    // else return false
    // console.log(userinfo,222)
     
  },
  countTime(createTime, fmt) {
    var timestamp = new Date().getTime() / 1000;
    var d,
      h,
      m,
      s,
      leftTime = timestamp - createTime;
    if (leftTime >= 0) {
      d = Math.floor(leftTime / 60 / 60 / 24);
      h = Math.floor((leftTime / 60 / 60) % 24);
      m = Math.floor((leftTime / 60) % 60);
      s = Math.floor(leftTime % 60);
    }
    if (d) {
      return d + '天' + h + '小时' + m + '分';
    } else if (h) {
      // return d + "天" + h + "小时" + m + "分" + s + "秒";
      return h + '小时' + m + '分';
    } else if (m) {
      return m + '分';
    } else {
      return s + '秒';
    }
  },
  /**
 * @description 团队
 */
teamform() {
  var arr = [
    {
      name: '队员',
      item: [
        {
            "system": "1",
            "key_name": "team_name",
            "show_name": "姓名",
            "type": "1",
            "rules": "",
            "options": "[]",
            "required": 1
        },
        {
            "system": "1",
            "key_name": "team_mobile",
            "show_name": "手机号码",
            "type": "1",
            "rules":"/^1\\d{10}$/",
            "options": "[]",
            "required": 1
        },
        {
            "system": "1",
            "key_name": "team_idtype",
            "show_name": "证件类型",
            "type": "3",
            "rules": "",
            "options": "[{\"key\":0,\"value\":\"\\u8eab\\u4efd\\u8bc1\"},{\"key\":1,\"value\":\"\\u62a4\\u7167\"},{\"key\":2,\"value\":\"\\u6e2f\\u6fb3\\u53f0\\u901a\\u884c\\u8bc1\"}]",
            "required": 1
        },
        {
            "system": "1",
            "key_name": "team_idnumber",
            "show_name": "证件号码",
            "type": "1",
            "rules": "",
            "options": "[]",
            "required": 1
        },
    
        {
            "system": "1",
            "key_name": "team_sex",
            "show_name": "性别",
            "type": "3",
            "rules": "",
            "options": "[{\"key\":0,\"value\":\"\\u7537\"},{\"key\":1,\"value\":\"\\u5973\"}]",
            "required": 1
        } 
      ]
    }     
  ]
  
  return arr;
  },
  async loginConfirm(to) {
    //wechat
    //清空本地缓存
    store.commit('clearUserInfo');
    try {
      let { code, t } = to.query;
      if (this.isEmpty(t)) {
        await storage.get('t').then((res) => {
          t = res
        })
      }

      if (typeOf(code) == 'array') code = code[code.length - 1]
      let params = { code }
     
      if (t) {
        //保存t用于分享
        storage.set('t', t);
        t = JSON.parse(Base64.decode(t))
        if (!!t.home) storage.set('home', t.home);
        params = Object.assign(params, t, { api_throw_exception: false })
        //保存home router 
        if (wechat.bridge.isWeChatMiniProgram && t.home.params.id != 16 && t.home.params.id != 39) {
          Dialog.confirm({
            title: '提示',
            message: '当前页面需要登录后才可访问,前往登录页面?',
          })
            .then(() => {
              wx.miniProgram.redirectTo({
                url: '/pages/user/userauth',
              });
            })
            .catch(() => {
              wx.miniProgram.reLaunch({
                url: '/pages/index/index',
              });
            });
        } else {
          const res = await api.system.wxLoginWap(params).then((res) => {
            if (+res.status !== 200) {
              throw 401
            } else {
              store.commit('setUserInfo', Object.assign(res.data, params));
              window.localStorage.removeItem("getCodeCount");
              return true;
            }
          });
          return res;
        }
      }else{
        if (wechat.bridge.isWeChatMiniProgram) {
          Dialog.confirm({
            title: '提示',
            message: '当前页面需要登录后才可访问,前往登录页面?',
          })
            .then(() => {
              wx.miniProgram.redirectTo({
                url: '/pages/user/userauth',
              });
            })
            .catch(() => {
              wx.miniProgram.reLaunch({
                url: '/pages/index/index',
              });
            });
        }
      }
    } catch (error) {
      let getCodeCount = window.localStorage.getItem("getCodeCount");
      if (this.isEmpty(getCodeCount)) getCodeCount = 0
      getCodeCount = +getCodeCount + 1
      //记录重试次数
      window.localStorage.setItem("getCodeCount", getCodeCount);
      if (+getCodeCount > 3) {
        Dialog.alert({
          message: '授权失败,请重新打开页面'
        }).then(() => {
          window.localStorage.removeItem("getCodeCount");
          // on close
        });
        return;
      }
      wechat.jsAuthorize()
    }
  }
};
